import { KnowledgeBaseSnippetKind } from 'types'
import { string } from 'yup'
import { safify } from '../utils/safify'

export const audience = string()
  .default('')
  .meta({
    label: 'Audience',
    placeholder: 'Who is the desired reader of the content?',
    snippets: [KnowledgeBaseSnippetKind.Audience],
    autoFill: true,
    skipReset: true,
    rows: 2,
  })
  .transform(safify)
